import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useFileDownloader from '../../useFileDownloader';

const useDownloadBADrivers = () => {
    const request = useFileDownloader();
    const [loading, setLoading] = useState(false);

    const onDownloadBADriversError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while downloading Demo Request '
        );
    };

    const onDownloadBADriversSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success("Driver verification started downloading");
    };

    const downloadBADrivers = () => {
        const url: HttpConfig = {
            url: `ba/v1/drivers/onboarding/export`,
            method: 'get',
        };

        request(url, onDownloadBADriversSuccess, setLoading, onDownloadBADriversError, 'DriverVerification.csv');
    };

    return { downloadBADrivers, loading };
};

export default useDownloadBADrivers;
